import {ContestStatus} from "../../../constants/PickXEnums";

export const handleContestCompleted = (state, action)=>{
    const index = state.contests.findIndex(c => c.Id === action.payload.ContestId);
    if (index !== -1) {
        state.contests[index].Status = ContestStatus.Completed;
        state.contests[index].IsOnLobby = false;
    }
}

export const handleContestCancelled = (state, action)=>{
    const index = state.contests.findIndex(c => c.Id === action.payload.ContestId);
    if (index !== -1) {
        state.contests[index].Status = ContestStatus.Cancelled;
        state.contests[index].IsOnLobby = false;
    }
};
export const handleContestRemoved = (state, action)=>{
    const index = state.contests.findIndex(c => c.Id === action.payload.ContestId);
    if (index !== -1) {
        state.contests.splice(index, 1);
    }
};
export const handleContestsUpdated = (state, action)=>{
    const index = state.contests.findIndex(c => c.Id === action.payload.ContestId);
    if (index !== -1) {
        const contest = state.contests[index];
        action.payload.Changes.forEach(c=>{
            contest[c.Name] = c.newValue;
        });
    }
};
export const handleContestsCreated = (state, action)=>{

};
export const handleContestStarted = (state, action)=>{
    const index = state.contests.findIndex(c => c.Id === action.payload.ContestId);
    if (index !== -1) {
        state.contests[index].DateStarted = new Date().toISOString();
        state.contests[index].Status = ContestStatus.Active;
        state.contests[index].IsOnLobby = false;
    }
};
export const handleContestValuesUpdated = (state, action)=>{
    const contest = state.contests.find(c => c.Id === action.payload.ContestId);
    if (contest) {
        contest.StatsValue = action.payload.StatsValue;
        contest.StatsCustomValue = action.payload.StatsCustomValue;
        contest.IsUnder = action.payload.IsUnder;
        contest.IsOver = action.payload.IsOver;
    }
};